// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:1280px){.content-width[data-v-502fb8ff]{max-width:800px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
